<template>
  <div>
    <h2 class="text-center mb-0">{{ header }}</h2>
    <table class="center dynamictable stripped w600 sticky-header">
      <caption class="header">Index kvality ovzdušia o {{ selectedDate | moment("DD.MM.YYYY HH:mm") }}</caption>
      <thead>
      <tr>
        <th class="w200 text-left">Stanica</th>
        <th>IKO</th>
        <th style="padding: 0; border: 0; background: transparent">&nbsp;</th>
        <th>PM<sub>10</sub></th>
        <th>PM<sub>2.5</sub></th>
        <th>NO<sub>2</sub></th>
        <th>O<sub>3</sub></th>
        <th>SO<sub>2</sub></th>
      </tr>
      </thead>
      <tbody>

      <tr v-for="station in ikoStations" :key="station.station_id">
        <td class="text-left nowrap">{{ station.station_name }}</td>
        <KoIKOTableColumn :station-id="station.station_id" :iko-data="ikoData" variable-color="iko_t" variable-value="iko_v" />
        <td style="padding: 1px; border:0">&nbsp;</td>
        <KoIKOTableColumn :station-id="station.station_id" :iko-data="ikoData" variable-color="pm10_t" variable-value="pm10_v" />
        <KoIKOTableColumn :station-id="station.station_id" :iko-data="ikoData" variable-color="pm25_t" variable-value="pm25_v" />
        <KoIKOTableColumn :station-id="station.station_id" :iko-data="ikoData" variable-color="no2_t" variable-value="no2_v" />
        <KoIKOTableColumn :station-id="station.station_id" :iko-data="ikoData" variable-color="o3_t" variable-value="o3_v" />
        <KoIKOTableColumn :station-id="station.station_id" :iko-data="ikoData" variable-color="so2_t" variable-value="so2_v" />
      </tr>

      </tbody>
    </table>


  </div>
</template>

<script>
import KoIKOTableColumn from "./KoIKOTableColumn";

export default {
  name: "KoIKOTable",
  components: {
    KoIKOTableColumn
  },
  props: {
    selectedDate: {
      type: String,
    },
    header: {
      type: String,
    },
    ikoData: {
      type: Array,
    },
    ikoStations: {
      type: Array,
    },
  },
  methods: {

  }
}
</script>

<style lang="scss">

</style>
